import React, { ReactNode } from 'react';
import { makeStyles, TableRow, TableRowProps } from '@material-ui/core';

import { brandTint } from 'utils/color-styles';

import { CollapsibleRow } from './CollapsibleRow';
import { CollapsibleRowToggle } from './CollapsibleRowToggle';

const useStyles = makeStyles({
  root: ({ collapsibleContent }) =>
    collapsibleContent
      ? {
          '& > *': {
            borderBottom: 'unset',
          },
        }
      : {},
});

export const TransactionTableRow = ({
  collapsibleContent,
  children,
  ...props
}: {
  collapsibleContent?: ReactNode;
} & Partial<TableRowProps>) => {
  const classes = useStyles({
    collapsibleContent,
  });
  const [open, setOpen] = React.useState(false);
  const handleCollapsibleOpen = (): void => setOpen(!open);

  return (
    <>
      <TableRow
        className={classes.root}
        onClick={handleCollapsibleOpen}
        style={{
          ...props.style,
          backgroundColor: open ? brandTint : 'initial',
        }}
        {...props}
      >
        {collapsibleContent ? (
          <CollapsibleRowToggle open={open} handleCollapsibleOpen={handleCollapsibleOpen} />
        ) : null}
        {children}
      </TableRow>
      {collapsibleContent ? (
        <CollapsibleRow open={open}>{collapsibleContent}</CollapsibleRow>
      ) : null}
    </>
  );
};
